export enum AppType {
    Agent,
    Direct
}
